module.exports = __webpack_public_path__ + "FACTE.png?e7f3b9819b4eaea89c75c0143d734ee9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global/img/FACTE.png
// module id = 28
// module chunks = 0